@if ((card?.template?.gameplay?.type??'') === 'filp') {
<div class="gameplay__container__box flip__container">
  <mat-card-title>{{ question?.name }}</mat-card-title>
  <mat-card-content class="choice__list__container">
    <mat-grid-list cols="4" rowHeight="100px">
      @for (choice of choices; track $index) {
      <mat-grid-tile
        class="flip-container"
        (click)="flipCard()"
      >
        <div class="flippable" [ngClass]="{ 'flipped': isFlipped }">
          <div class="front">
            {{ choice.name }}
            <img [src]="choice.resources[0].url" alt="{{choice.name}}" (click)="onSelect(choice)" />
          </div>
          <div class="back">
            <h2>"{{isCorrect() ? 'Yes' : 'No'}}"</h2>
          </div>
        </div>
      </mat-grid-tile>
    }
    </mat-grid-list>
  </mat-card-content>
</div>
}
